import { defineNuxtPlugin } from '#app'
import { recoverPageWithHardReload } from '~/composables/usePageRecovery'

const HIDDEN_THRESHOLD_MS = import.meta.dev ? 60_000 : 60 * 60_000

export default defineNuxtPlugin(() => {
  let lastHiddenAt: number | null = null
  let isRecovering = false

  async function onTabReturn() {
    if (isRecovering) return
    isRecovering = true

    try {
      const route = useRoute()
      await recoverPageWithHardReload(route.fullPath)
    } finally {
      isRecovering = false
    }
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      lastHiddenAt = Date.now()
      return
    }

    if (document.visibilityState !== 'visible' || lastHiddenAt === null) return

    const hiddenMs = Date.now() - lastHiddenAt
    lastHiddenAt = null

    if (hiddenMs < HIDDEN_THRESHOLD_MS) return

    onTabReturn()
  }

  function onPageShow(event: PageTransitionEvent) {
    if (!event.persisted || lastHiddenAt === null) return

    const hiddenMs = Date.now() - lastHiddenAt
    lastHiddenAt = null

    if (hiddenMs < HIDDEN_THRESHOLD_MS) return

    onTabReturn()
  }

  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('pageshow', onPageShow)
})
